import React from "react";


function ViewBanner() {
  return (
    <div
      className="view flex flex-col justify-between px-[16px] md:px-[24px]    py-[24px]   text-white font-Rubik md:h-[660px] h-[414px] w-full object-cover     "
      style={{

        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h5 className="text-[#bd0000] font-semibold text-[22px]">
      
      </h5>
      <div className="container lg:mx-auto md:pb-[150px] pb-[50px]">
        <div className="md:w-[585px] italic flex flex-col gap-[16px]">
          <h2 className="md:text-[40px] text-[28px] uppercase font-medium">
            Cricket Legacy of<br />
            St. John’s College Jaffna
          </h2>
          <p className="capitalize md:text-[20px] text-[14px] text-justify font-light text-[white]">
            St. John’s College Jaffna has a rich cricketing history, playing the annual
            “Battle of the North” against Jaffna Central College since 1904,
            one of Sri Lanka’s oldest school cricket rivalries.
            It remains a proud and cherished tradition.
          </p>
        </div>
      </div>
    </div>
  );
}

export default ViewBanner;
